var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopularagencies1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2074_22450",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2074_22450)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2074_22450",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2074_22450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 5.78125V4.21875C6.25 3.96094 6.46094 3.75 6.71875 3.75H8.28125C8.53906 3.75 8.75 3.96094 8.75 4.21875V5.78125C8.75 6.03906 8.53906 6.25 8.28125 6.25H6.71875C6.46094 6.25 6.25 6.03906 6.25 5.78125ZM11.7188 6.25H13.2812C13.5391 6.25 13.75 6.03906 13.75 5.78125V4.21875C13.75 3.96094 13.5391 3.75 13.2812 3.75H11.7188C11.4609 3.75 11.25 3.96094 11.25 4.21875V5.78125C11.25 6.03906 11.4609 6.25 11.7188 6.25ZM6.71875 10H8.28125C8.53906 10 8.75 9.78906 8.75 9.53125V7.96875C8.75 7.71094 8.53906 7.5 8.28125 7.5H6.71875C6.46094 7.5 6.25 7.71094 6.25 7.96875V9.53125C6.25 9.78906 6.46094 10 6.71875 10ZM11.7188 10H13.2812C13.5391 10 13.75 9.78906 13.75 9.53125V7.96875C13.75 7.71094 13.5391 7.5 13.2812 7.5H11.7188C11.4609 7.5 11.25 7.71094 11.25 7.96875V9.53125C11.25 9.78906 11.4609 10 11.7188 10ZM8.75 13.2812V11.7188C8.75 11.4609 8.53906 11.25 8.28125 11.25H6.71875C6.46094 11.25 6.25 11.4609 6.25 11.7188V13.2812C6.25 13.5391 6.46094 13.75 6.71875 13.75H8.28125C8.53906 13.75 8.75 13.5391 8.75 13.2812ZM11.7188 13.75H13.2812C13.5391 13.75 13.75 13.5391 13.75 13.2812V11.7188C13.75 11.4609 13.5391 11.25 13.2812 11.25H11.7188C11.4609 11.25 11.25 11.4609 11.25 11.7188V13.2812C11.25 13.5391 11.4609 13.75 11.7188 13.75ZM18.75 18.5938V20H1.25V18.5938C1.25 18.3359 1.46094 18.125 1.71875 18.125H2.48047V0.9375C2.48047 0.417969 2.89844 0 3.41797 0H16.582C17.1016 0 17.5195 0.417969 17.5195 0.9375V18.125H18.2812C18.5391 18.125 18.75 18.3359 18.75 18.5938ZM4.35547 18.0859H8.75V15.4688C8.75 15.2109 8.96094 15 9.21875 15H10.7812C11.0391 15 11.25 15.2109 11.25 15.4688V18.0859H15.6445V1.91406L4.375 1.875L4.35547 18.0859Z",
    fill: "#6F70FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopularagencies1);
export default __webpack_public_path__ + "static/media/popularagencies1.120534ad3467b870e92934cfc9150fbd.svg";
export { ForwardRef as ReactComponent };